import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	termination: null,
	error: "",
	loading: false,
};

// ADD_termination
export const addTermination = createAsyncThunk(
	"termination/addTermination",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `termination`,
				data: {
					...values,
				},
			});
			toast.success("Termination added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding termination try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_termination
export const deleteOverTime = createAsyncThunk(
	"termination/deleteOverTime ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `termination/${id}`,
			});

			toast.success("Termination deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting termination try again");
			console.log(error.message);
		}
	}
);


// termination
export const getAllTermination = createAsyncThunk(
	"termination/getAllTermination",
	async () => {
		try {
			const { data } = await axios.get(`termination`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateTermination = createAsyncThunk(
	"termination/updateTermination",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `termination/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Termination updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating termination try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const terminationSlice = createSlice({
	name: "termination",
	initialState,
	reducers: {
		clearTermination: (state) => {
			state.termination = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllTermination ======

		builder.addCase(getAllTermination.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllTermination.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllTermination.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addTermination  ======

		builder.addCase(addTermination.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addTermination.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addTermination.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

	},
});

export default terminationSlice.reducer;
export const { clearTermination } = terminationSlice.actions;
